import React, { Component } from 'react';
import Server from './Server.js'
export class  ComponentToPrint extends React.Component {

  constructor(props) {
    super(props);
    this.Server = new Server();
    this.state = {
      param:this.props.param,
      html:'',
      url: this.Server.getUrl(),
      absoluteUrl: this.Server.getAbsoluteUrl(),

    }




  }
  componentWillReceiveProps(newProps){
    
    if(newProps.htmlParam){
      this.setState({
        html:newProps.htmlParam
      })
    }
  }
  render() {

   

    return (
      <div style={{ direction: 'rtl' }}>
          <div dangerouslySetInnerHTML={{ __html: this.state.html}} ></div>
      </div>
    )
  }
}
